/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components/macro';
import { Spacer, Title, Text } from 'components/atoms';


const SubWebCourses = () => (
  <Wrapper>
    <Spacer spacing="xl5">
      <Center>
        <Title>Cursos</Title>
        <Text modifiers={['content', 'center']}>
          O módulo de cursos contém links para as diferentes tipologias de cursos oferecidas nos departamentos ou escolas da UA, como forma de acesso rápido às páginas de cada tipologia (licenciaturas e mestrados integrados, mestrados, programas doutorais, etc.)
        </Text>
      </Center>
    </Spacer>
  </Wrapper>
)

const Center = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
`;

const Wrapper = styled.div`
  border-bottom: 1px solid ${props => props.theme.colors.borderLighter};
`;

export default SubWebCourses;
